export enum DialerNextPhoneTiming {
  SAME_PASS = "SAME_PASS",
  NEXT_PASS = "NEXT_PASS",
}
